import { render } from "./SyncLogComponent.vue?vue&type=template&id=7cfda6bd&ts=true"
import script from "./SyncLog.service.ts?vue&type=script&lang=ts&external"
export * from "./SyncLog.service.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__